<template>
  <div
    id="quick-tour"
    ref="tour"
    :class="{
      shipping: active.id === 'order-shipping-0',
      'review-pdp-filter-review': active.id === 'review-pdp-filter-review',
    }"
    :style="position"
    class="quick-tour new"
  >
    <div v-if="active.title" :class="{ 'title-number': active.showNumber }" class="title">
      <p>
        <span v-if="active.showNumber" class="number">{{ active.index + 1 }}</span
        >{{ active.title }}
      </p>
      <p v-if="active.showNumber" class="number">{{ active.index + 1 + '/' + tours.length }}</p>
    </div>
    <div class="content" v-html="active.content"></div>
    <div
      :class="{ 'flex-end': tours.length - 1 === active.index && active.id !== 'review-pdp-filter-review' }"
      class="bottom"
    >
      <a v-if="tours.length - 1 != active.index" @click.prevent="closeTour">{{ active.skip_title }}</a>
      <button class="button-quick-tour" @click="nextTour">{{ active.next_title }}</button>
    </div>
    <div :class="getArrow" class="tour-arrow"></div>
  </div>
</template>

<script>
export default {
  name: 'ModalTour',
  props: {
    tours: {
      type: Array,
      required: true,
      default: () => [],
    },
    active: {
      type: Object,
      required: true,
      default: () => {},
    },
    close: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      position: '',
    };
  },
  computed: {
    is_desktop() {
      return this.$store.state.screen.isDesktop;
    },
    width() {
      return this.$store.state.screen.width;
    },
    getArrow() {
      if (this.is_desktop) {
        return this.active.arrow;
      } else {
        return this.active.arrow_mobile;
      }
    },
    maxWidthStyle() {
      if (!this.is_desktop) {
        if (this.width) {
          return 'max-width: ' + (this.width - 100) + 'px;';
        }
      }
      return '';
    },
  },
  mounted() {
    this.$nextTick(() => this.getPosition());
    document.documentElement.classList.add('noscroll');
    document.body.classList.add('no-scroll');
  },
  beforeDestroy() {
    document.documentElement.classList.remove('noscroll');
    document.body.classList.remove('no-scroll');
  },
  methods: {
    getPosition() {
      let style = this.active.style || '';
      let width = true;
      const elm = document.getElementById(this.active.id);
      if (this.active.scroll) {
        elm.scrollIntoView({ block: 'center' });
      }
      const position = this.active.position;
      this.overlay(elm, this.active.overlay);
      this.highlightElm(elm, true);
      if (position && elm.offsetHeight) {
        if (position === 'bottom') {
          style += 'top:' + (elm.offsetHeight + 20) + 'px;';
        } else if (position === 'top') {
          style += 'top:auto;bottom:' + (elm.offsetHeight + 20) + 'px;';
        }
      }

      // custom style
      if (this.active.id === 'review-tag-0') {
        width = false;
      } else if (this.active.id === 'review-pdp-filter-review') {
        width = false;
      }

      if (width) {
        style += 'width:' + (this.width - 100) + 'px;';
      }

      this.position = style + this.maxWidthStyle;
    },
    highlightElm(elm, display) {
      let style = '';
      if (display) {
        style += 'z-index:9999;pointer-events:none;position:relative;overflow:unset;';

        //cutom style
        if (this.active.id === 'home-selfcheckout-1') {
          style += 'background:#ffffff;right:8px;padding:10px;border-radius:50%;position:absolute;';
        } else if (this.active.id === 'order-selfcheckout-1') {
          style += 'background:#ffffff;';
        } else if (this.active.id === 'product-selfcheckout-0') {
          style += 'background:#ffffff;border-radius:5px;padding:0 5px;';
        }
        style += this.active.highlightStyle || '';
      }
      elm.setAttribute('style', style);
    },
    overlay(elm, display) {
      if (display) {
        const overlay = document.createElement('div');
        overlay.setAttribute('id', 'overlay-' + this.active.id);
        overlay.setAttribute(
          'style',
          'position:fixed;z-index:9998;top:0;left:0;right:0;bottom:0;width:100%;height:100%;background-color:rgba(0, 0, 0, .5);'
        );
        elm.parentNode.append(overlay);
      } else {
        if (document.getElementById('overlay-' + this.active.id)) {
          document.getElementById('overlay-' + this.active.id).remove();
        }
      }
    },
    nextTour() {
      this.setSetCoachmark();
      const elm = document.getElementById(this.active.id);
      this.highlightElm(elm, false);
      this.overlay(elm, false);
      const index = this.active.index + 1;
      if (this.tours.length !== index) {
        this.$store.dispatch('showTour', { index });
      } else {
        document.documentElement.classList.remove('noscroll');
        document.body.classList.remove('no-scroll');
        setTimeout(() => this.$store.commit('setTours', []), 100);
        window.scrollTo(0, 0);
      }
      this.close();
    },
    closeTour() {
      this.setSetCoachmark();
      document.documentElement.classList.remove('noscroll');
      document.body.classList.remove('no-scroll');
      const elm = document.getElementById(this.active.id);
      this.highlightElm(elm, false);
      this.overlay(elm, false);
      setTimeout(() => this.$store.commit('setTours', []), 100);
      window.scrollTo(0, 0);
      this.close(true);
    },
    setSetCoachmark() {
      if (this.active.coachmark) {
        this.$store.dispatch('setQuickTour', this.active.coachmark);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin arrow-top {
  clip-path: polygon(50% 0, 0 100%, 100% 100%);
  width: 40px;
  height: 20px;
  top: -15px;
  position: absolute;
  border: none !important;
  background-color: #f384a7;
}

@mixin arrow-bottom {
  clip-path: polygon(50% 100%, 0 0, 100% 0);
  width: 40px;
  height: 20px;
  bottom: -15px;
  position: absolute;
  border: none !important;
  background-color: #f384a7;
}

@mixin arrow-right {
  clip-path: polygon(100% 50%, 0 0, 0 100%);
  width: 20px;
  height: 40px;
  right: -18px;
  position: absolute;
  border: none !important;
  background-color: #f384a7;
}

.quick-tour {
  background: #f384a7;
  color: #231f20;
  max-width: 466px;
  border-radius: 3px;
  filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.5));
  padding: 30px;
  text-align: center;
  z-index: 9999;
  margin-top: 0.5rem;
  transition: opacity 600ms, visibility 600ms;
  position: absolute;
  will-change: transform;
  top: 0px;
  left: 0px;
  .top-right {
    @include arrow-top;
    right: 1rem;
  }
  .top-left {
    @include arrow-top;
    left: 1rem;
  }
  .bottom-right {
    @include arrow-bottom;
    right: 1rem;
  }
  .bottom-left {
    @include arrow-bottom;
    left: 1rem;
  }
  .right-bottom {
    @include arrow-right;
    bottom: 1rem;
  }
  .right-top {
    @include arrow-right;
    top: 1rem;
  }
  .title > p {
    font-family: $lato_regular;
    letter-spacing: 1.78px;
    text-align: left;
    text-transform: uppercase;
    font-size: 14px;
    color: #ffffff;
  }
  .content ::v-deep {
    p {
      font-size: 13px;
      color: #ffffff;
      line-height: 18px;
      font-family: $lato_regular;
      letter-spacing: 0;
      text-align: left;
      .pink-font {
        color: #da2a52;
        font-family: $lato_regular;
      }
    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    align-items: flex-end;
    a {
      font-family: $lato_regular;
      font-size: 12px;
      color: #c7878d;
      letter-spacing: 0;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  &.new {
    pointer-events: auto !important;
  }
  &.review-pdp-filter-review {
    background: #ffffff;
    .title > p {
      text-transform: unset;
      letter-spacing: unset;
      font-family: $lato_regular;
      font-weight: bold;
      color: #da2a52;
    }
    .content ::v-deep p {
      font-family: $lato_regular;
      color: #231f20;
    }
    .tour-arrow {
      background-color: #ffffff !important;
    }
  }
}
.pink-font {
  color: #da2a52;
  font-family: $lato_regular;
}
.button-quick-tour {
  background: #da2a52;
  border: none;
  border-radius: 4px;
  font-family: 'Lato-Bold', sans-serif;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 2px;
  text-align: center;
  height: 36px;
  padding: 0 40px;
  text-transform: uppercase;
}

.flex-end {
  justify-content: flex-end !important;
}

@media (max-width: 991px) {
  .first-quick-tour {
    width: 80%;
    padding: 30px 20px;
  }
  .quick-tour {
    width: 80%;
    padding: 20px;
    .title > p {
      font-family: $lato_regular;
      text-transform: uppercase;
      font-size: 14px;
      letter-spacing: 1.56px;
      border: none;
      padding: 0;
    }
    .content ::v-deep {
      p {
        font-family: $lato_regular;
        font-size: 13px;
        padding: 0;
        text-transform: none;
        border: none;
        .pink-font {
          color: #da2a52;
          font-family: $lato_regular;
        }
      }
    }
    .bottom {
      a {
        text-transform: none;
      }
    }
  }
}
</style>
